var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Stream from './Stream.jsx';
import Tracker from './Tracker.jsx';
import { fetchBetradarStreamUrl, resetBetradar } from '../../../../actions/creators/betradar';
function isAvailableStreamSport(sportId) {
    return [7, 31, 30].includes(sportId);
}
var LiveMatchWidgets = /** @class */ (function (_super) {
    __extends(LiveMatchWidgets, _super);
    function LiveMatchWidgets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.fetchStreamUrl();
        };
        _this.componentDidUpdate = function (prevProps) {
            var _a = _this.props, balance = _a.balance, gamblerId = _a.gamblerId;
            if (prevProps.gamblerId !== gamblerId || (prevProps.balance !== balance && balance > 0)) {
                _this.fetchStreamUrl();
            }
        };
        _this.fetchStreamUrl = function () {
            var _a = _this.props, radarId = _a.radarId, balance = _a.balance, sportId = _a.sportId, gamblerId = _a.gamblerId;
            if (radarId && balance > 0 && gamblerId && isAvailableStreamSport(sportId)) {
                _this.props.fetchBetradarStreamUrl(radarId);
            }
        };
        _this.componentWillUnmount = function () {
            _this.props.resetBetradar();
        };
        return _this;
    }
    LiveMatchWidgets.prototype.render = function () {
        var _a = this.props, radarId = _a.radarId, sportId = _a.sportId, streamUrl = _a.streamUrl, showStream = _a.showStream;
        return (_jsx("div", __assign({ className: "betradar" }, { children: streamUrl && showStream
                ? _jsx(Stream, { radarId: radarId, streamUrl: streamUrl })
                : _jsx(Tracker, { radarId: radarId, sportId: sportId }) })));
    };
    return LiveMatchWidgets;
}(Component));
function mapStateToProps(state, props) {
    var betradar = state.betradar;
    var gamblerId = state.auth.user.gamblerId;
    var balance = state.balance.value;
    return __assign(__assign(__assign({}, props), betradar), { balance: balance, gamblerId: gamblerId });
}
export default connect(mapStateToProps, { fetchBetradarStreamUrl: fetchBetradarStreamUrl, resetBetradar: resetBetradar })(LiveMatchWidgets);



// WEBPACK FOOTER //
// ./src/components/grid/event/LiveMatchWidgets/index.js